import createApi from '@/services/Api';
import moment from 'moment';
import { waitFactory } from '@/utils/wait';

function Meetings() {
  const api = createApi();

  function fetchMeetingsByDay(moment) {
    const endpoint = `/profissional-saude/dashboard/atendimentos`;
    const dateParam = moment.format('DD/MM/YYYY');

    return api
      .get(endpoint, {
        params: {
          data: dateParam,
        },
        transformResponse: new Array().concat(
          api.defaults.transformResponse,
          data => {
            data.object = filterMeetingsFetching(data.object);
            return data;
          },
        ),
      })
      .then(waitFactory(200));
  }

  function createMeeting(param) {
    const endpoint = `/profissional-saude/dashboard/atendimentos`;
    return api.post(endpoint, param);
  }

  function rescheduleMeeting([appointment, id]) {
    const endpoint = `/profissional-saude/dashboard/atendimentos/${id}`;
    return api.patch(endpoint, appointment);
  }

  function cancelMeeting([id, reason]) {
    const endpoint = `/profissional-saude/dashboard/atendimentos/${id}`;
    return api.delete(endpoint, {
      data: {
        motivoCancelamento: reason,
      },
    });
  }

  function fetchAvailableTimes(moment) {
    const endpoint = `/profissional-saude/agendas/horarios-disponiveis`;
    const dateParam = moment.format('DD/MM/YYYY');
    return api.get(endpoint, {
      params: {
        data: dateParam,
      },
    });
  }

  function filterMeetingsFetching(resMeetings) {
    const meetings = resMeetings.map(meeting => {
      const { id, convenio, dataHora, paciente, objetivo, status } = meeting;

      const obj = Object.assign({
        id,
        status: status,
        meetType: objetivo,
        healthInsurance: convenio,
        historyToken: paciente.tokenHistorico,
        moment: moment(dataHora, 'DD/MM/YYYY kk:mm'),
        invited: {
          name: paciente.nome,
          image: null,
        },
      });

      return obj;
    });

    return meetings.sort(orderByMoment);
  }

  function orderByMoment(itemA, itemB) {
    if (itemA.moment.isBefore(itemB.moment, 'minute')) return -1;
    if (itemA.moment.isAfter(itemB.moment, 'minute')) return 1;
    return 0;
  }

  return {
    fetchMeetingsByDay,
    fetchAvailableTimes,
    createMeeting,
    rescheduleMeeting,
    cancelMeeting,
  };
}

export default Meetings();
